import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SmartViewRoutingModule } from './smart-view-routing.module';
import { SmartViewComponent } from './smart-view.component';
import { SharedModule } from '../shared/shared.module';
import { GlobalDepartmentModule } from '../global/global-department/global-department.module';
import { GlobalLoginModule } from '../global/global-login/global-login.module';
import { QuickViewPopupModule } from '../global/quick-view-popup/quick-view-popup.module';
import { SaveIdeaPopupModule } from '../global/save-idea-popup/save-idea-popup.module';

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ChatPopoverModule } from '../chat-popover/chat-popover.module';

@NgModule({
  declarations: [
    SmartViewComponent
  ],
  imports: [
    CommonModule,
    SmartViewRoutingModule,
    SharedModule,
    GlobalDepartmentModule,
    GlobalLoginModule,
    QuickViewPopupModule,
    SaveIdeaPopupModule,
    OverlayPanelModule,
    SidebarModule,
    DialogModule,
    ButtonModule,
    ChatPopoverModule
  ]
})
export class SmartViewModule { }
